import { render, staticRenderFns } from "./tourist.vue?vue&type=template&id=76b8a175&scoped=true&"
import script from "./tourist.vue?vue&type=script&lang=js&"
export * from "./tourist.vue?vue&type=script&lang=js&"
import style0 from "./tourist.vue?vue&type=style&index=0&id=76b8a175&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b8a175",
  null
  
)

export default component.exports